const state = () => {
  return {
    previousRoute: null,
    showBottomBar: true,
  };
};

const getters = {
  showBottomBar(state) {
    return state.showBottomBar;
  },
};

const actions = {};

const mutations = {
  setPreviousRoute(state, route) {
    state.previousRoute = route;
  },
  setShowBottomBar(state, show) {
    state.showBottomBar = show;
  },
};

export default {
  namespaced: true,
  state,
  getters,
  actions,
  mutations,
};
